import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ProtectedRoute = ({ children, requireAuth = true }) => {
  const { isAuthenticated, isLoading, isInitialized } = useAuth();
  const location = useLocation();

  // Don't show loading screen on login page to avoid bad UX
  const isLoginPage = location.pathname === "/login";

  // Show loading while authentication is being initialized, but not on login page
  if ((!isInitialized || isLoading) && !isLoginPage) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // If authentication is required but user is not authenticated
  if (requireAuth && !isAuthenticated()) {
    // Redirect to login with return URL
    return (
      <Navigate
        to={`/login?returnUrl=${encodeURIComponent(
          location.pathname + location.search
        )}`}
        replace
      />
    );
  }

  // If authentication is not required but user is authenticated (e.g., login page)
  // Only redirect if auth is fully initialized to avoid premature redirects
  if (!requireAuth && isAuthenticated() && isInitialized && !isLoading) {
    // Redirect to home or intended destination
    const returnUrl = new URLSearchParams(location.search).get("returnUrl");
    return <Navigate to={returnUrl || "/normal-post"} replace />;
  }

  return children;
};

export default ProtectedRoute;
